import { defineStore } from 'pinia';
import { readonly, ref } from 'vue';

export const useCommonStore = defineStore('common', () => {
  const isNavigationMenuOpen = ref(false);
  const isWebView = document.body.classList.contains('webview');
  const isAndroid = /android/i.test(window.navigator.userAgent);

  const openNavigationMenu = () => {
    isNavigationMenuOpen.value = true;
  };

  const closeNavigationMenu = () => {
    isNavigationMenuOpen.value = false;
  };

  return { isNavigationMenuOpen: readonly(isNavigationMenuOpen), isWebView, isAndroid, openNavigationMenu, closeNavigationMenu };
});
